module.exports = __webpack_public_path__ + "static/img/24-Bracknell-Lexicon.785324cf.jpg";